import { usePostHog } from "posthog-js/react";

const WORDING_NSFW = {
    BTN_FILTER: 'NSFW',
    AMV_LOCKED_CONTENT: 'Contenu NSFW',
    FEED_LOCKED_CONTENT: 'Contenu NSFW',
    THUMBNAIL: 'Voir contenu NSFW',
    VIDEO_DURATION_LIMIT : 'NSFW 🔥 ',
    ENCOURAGE : 'Vidéos NSFW 🔥 sans limite de durée'
}

const WORDING_NSFW_HOT = {
    BTN_FILTER: 'Hot',
    AMV_LOCKED_CONTENT: 'Contenu Hot',
    FEED_LOCKED_CONTENT: 'Contenu Hot',
    THUMBNAIL: 'Voir contenu Hot',
    VIDEO_DURATION_LIMIT : 'Hot 🔥 ',
    ENCOURAGE : 'Vidéos Hot 🔥 sans limite de durée'
}

const useWordingNSFW = () => {
    const posthog = usePostHog();
    const variant = posthog.getFeatureFlag('nsfw-wording');
    return variant === 'hot' ? WORDING_NSFW_HOT : WORDING_NSFW;
}

export default useWordingNSFW;